function arrayShallowEquality(array1, array2) {
  console.debug(`[array-helper] Comparing arrays`, {array1, array2});
  if(array1.length !== array2.length) {
    return false;
  }
  return array1.every((value, index) => value === array2[index]);
}

export {arrayShallowEquality};
